import { Locale } from 'chaika-enums';

export function parseStringToLocale(localeString: string) {
    let locale;

    switch (localeString) {
        case 'ru': {
            locale = Locale.Ru;
            break;
        }
        case 'en': {
            locale = Locale.En;
            break;
        }
        case 'ge': {
            locale = Locale.Ge;
            break;
        }
        case 'am': {
            locale = Locale.Am;
            break;
        }
        default: {
            locale = Locale.Ru;
        }
    }

    return locale;
}
